import BaseRailsRequestController from "./base_rails_request_controller";

// Connects to data-controller="checkbox-request"
export default class extends BaseRailsRequestController {
  static values = {
    url: String,
    onlyOnChecked: Boolean,
    errorMessage: String,
  };

  initialize() {
    this.revertCheckboxChange = this.revertCheckboxChange.bind(this);
  }

  revertCheckboxChange() {
    if (!this.checkbox) return;
    if (event.detail.checkboxId !== this.checkboxId) return;

    this.checkbox.checked = !this.checkbox.checked;
  }

  request(event) {
    if (!this.hasUrlValue) return;

    this.checkbox = event.currentTarget;
    this.checkboxId = this.checkbox.dataset.id;

    if (this.checkbox.dataset.disableModal === "true") return;
    if (this.onlyOnCheckedValue && !this.checkbox.checked) return; // If onlyOnChecked is true, we only send the request if the checkbox is checked

    this.checkbox.disabled = true;

    this.handleRequest();
  }

  handleRequest() {
    // Remove event listener if it never triggered for other requests
    window.removeEventListener("modal:revert-checkbox-changes", this.revertCheckboxChange);

    return this.fetchWithProgress("get", this.urlValue, {
      responseKind: "turbo-stream",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        window.addEventListener("modal:revert-checkbox-changes", this.revertCheckboxChange, {
          once: true,
        });
      })
      .catch((error) => {
        console.error("Error handling request:", error);
        window.dispatchEvent(new CustomEvent("flash:create", { detail: { type: "danger", message: this.errorMessageValue } }));
      })
      .finally(() => {
        this.checkbox.disabled = false;
      });
  }
}
